export const PaginationButton = (
  value,
  onClick,
  disabled = false,
  isActive = false,
  isPageButton = false,
) => {
  if (isPageButton) {
    return (
      <button
        className={`pagination-button page ${isActive ? 'active-page' : ''}`}
        key={value}
        onClick={() => onClick(value)}
        disabled={disabled}
      >
        {value}
      </button>
    );
  }

  return (
    <button
      className="pagination-button arrow"
      onClick={onClick}
      disabled={disabled}
    >
      {value}
    </button>
  );
};
